// Real Google Business Profile reviews for TyresPro Ltd
// Manually curated — matches the display on the live Google Business Profile.

export const REVIEWS = [
  {
    name: "Keith Scully",
    initial: "K",
    color: "#0F9D58", // Google green
    reviewCount: 1,
    photos: 0,
    localGuide: false,
    rating: 5,
    time: "16 hours ago",
    text: "Came out on a Sunday to solve tyre issue, no issues got back on road swiftly",
    reply: {
      time: "16 hours ago",
      text: "Thank you, Keith! We're glad we could help and get you back on the road quickly. We appreciate your support!",
    },
  },
  {
    name: "Saba",
    initial: "S",
    color: "#DB4437", // Google red
    reviewCount: 7,
    photos: 2,
    localGuide: true,
    rating: 5,
    time: "2 days ago",
    text: "My tyre went flat late at night, I called few places that claim 24/7 tyre replacement services, none of them answered....",
    reply: {
      time: "Yesterday",
      text: "Thanks for your time and effort for this excellent review 👍",
    },
  },
  {
    name: "Emily Kent",
    initial: "E",
    color: "#4285F4", // Google blue
    reviewCount: 3,
    photos: 0,
    localGuide: false,
    rating: 5,
    time: "2 days ago",
    text: "Excellent service. Came within the hour, very professional and friendly.",
    reply: {
      time: "Yesterday",
      text: "Thanks for review 👍",
    },
  },
  {
    name: "Jason Abel",
    initial: "J",
    color: "#F4B400", // Google yellow
    reviewCount: 2,
    photos: 0,
    localGuide: false,
    rating: 5,
    time: "3 days ago",
    text: "Excellent work and would recommend — came and fitted a new tyre within an hour of calling. Thank you very much.",
    reply: {
      time: "3 days ago",
      text: "Thank you for reviewing 😃",
    },
  },
  {
    name: "Thomas Douglas",
    initial: "T",
    color: "#673AB7",
    reviewCount: 2,
    photos: 0,
    localGuide: false,
    rating: 5,
    time: "7 days ago",
    text: "Great, fast service — would highly recommend.",
    reply: {
      time: "7 days ago",
      text: "Thank you for reviewing! 😃",
    },
  },
  {
    name: "Waqas Saeed",
    initial: "W",
    color: "#009688",
    reviewCount: 5,
    photos: 0,
    localGuide: false,
    rating: 5,
    time: "1 week ago",
    text: "Very efficient and quick service.",
    reply: {
      time: "7 days ago",
      text: "Thank you for reviewing! 😃",
    },
  },
  {
    name: "Der Castle",
    initial: "D",
    color: "#E91E63",
    reviewCount: 8,
    photos: 0,
    localGuide: false,
    rating: 5,
    time: "1 week ago",
    text: "Answered straight away, came within 20 minutes and fixed everything back up. Really friendly guy and got straight to fixing the issue, would definitely recommend!",
    reply: {
      time: "1 week ago",
      text: "Thank you for reviewing! 😃",
    },
  },
];

export const REVIEW_SUMMARY = {
  rating: 5.0,
  count: REVIEWS.length,
  googleUrl: "https://g.page/r/CdYeJ0rW57UFEAI",
  writeReviewUrl: "https://g.page/r/CdYeJ0rW57UFEAI/review",
};
